<template>
  <a :href="to" :class="{ [activeClass]: isSameUrl }" :target="target">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    to: {
      type: [String, Object]
    },
    tag: {
      type: String
    },
    'active-class': {
      type: String,
      default: 'router-link-active'
    },
    target: {
      type: String
    }
  },
  computed: {
    isSameUrl() {
      if (this.$route == undefined) {
        return false
      }

      if (this.$route.path == undefined) {
        return false
      }

      return this.$route.path == this.to
    }
  }
}
</script>
